import { BranchTimelineEntryDto } from "@kuika/kuika-cl-model/src/dtos/branch.dto";

/**
 * Resolve which commit the branch HEAD points at (the "Current" commit).
 * Prefers the server-reported `headCommitId` when it matches a commit in the timeline — this is
 * what keeps the marker correct after a restore/revert (HEAD moves to the restored commit, not the
 * newest-by-number one). Falls back to the newest commit when HEAD is unresolved: legacy payloads
 * without `headCommitId`, or a milestone restore whose snapshot has no owning commit.
 */
export function resolveCurrentCommitId(
  headCommitId: string | undefined,
  commits: BranchTimelineEntryDto[]
): string | undefined {
  if (headCommitId && commits.some((c) => c.commitId === headCommitId)) {
    return headCommitId;
  }
  return commits[0]?.commitId;
}
